import { render, staticRenderFns } from "./IncidentTemplate.vue?vue&type=template&id=1f18eab6&"
import script from "./IncidentTemplate.vue?vue&type=script&lang=js&"
export * from "./IncidentTemplate.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports